export default {"src":"/_next/static/media/neutral_24.3da3e98e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};